/**
 * 文件处理状态枚举
 * 支持两阶段处理：上传 + 识别
 */
export enum FileProcessStatus {
    /** 空闲状态 */
    IDLE = 'idle',
    /** 第一阶段：上传中 */
    UPLOADING = 'uploading',
    /** 第一阶段：上传成功 */
    UPLOAD_SUCCESS = 'upload_success',
    /** 第二阶段：识别中 */
    RECOGNIZING = 'recognizing',
    /** 第二阶段：识别成功 */
    RECOGNITION_SUCCESS = 'recognition_success',
    /** 第一阶段：上传失败 */
    UPLOAD_FAILED = 'upload_failed',
    /** 第二阶段：识别失败 */
    RECOGNITION_FAILED = 'recognition_failed',
}
